// import React from "react";
// import { useNavigate } from "react-router-dom";

// const LeadersPage = () => {
//   const navigate = useNavigate();

//   const countries = [
//     { name: "India", year: 1956, flag: "🇮🇳" },
//     { name: "Afghanistan", year: 2018, flag: "🇦🇫" },
//     { name: "Bahrain", year: 1978, flag: "🇧🇭" },
//     { name: "Bangladesh", year: 1958, flag: "🇧🇩" },
//     { name: "Bhutan", year: 2010, flag: "🇧🇹" },
//     { name: "Iraq", year: 2006, flag: "🇮🇶" },
//     { name: "Jordan", year: 1953, flag: "🇯🇴" },
//     { name: "Lebanon", year: 1952, flag: "🇱🇧" },
//     { name: "Maldives", year: 2006, flag: "🇲🇻" },
//     { name: "Nepal", year: 1971, flag: "🇳🇵" },
//     { name: "Pakistan", year: 1956, flag: "🇵🇰" },
//     { name: "Palestine", year: 2009, flag: "🇵🇸" },
//     { name: "Srilanka", year: 1958, flag: "🇱🇰" },
//     { name: "UAE", year: 2015, flag: "🇦🇪" }
//   ];

//   return (
//     <div style={{ padding: 20, fontFamily: "Arial, sans-serif" }}>
//       {/* Image Section */}
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           justifyContent: "center",
//           marginBottom: 30
//         }}
//       >
//         {/* Left Image + Button */}
//         <div style={{ margin: 10, textAlign: "center" }}>
//           <img
//             src="/left-image.jpg"
//             alt="International Leader"
//             style={{ width: "100%", maxWidth: 300, height: "auto" }}
//           />
//           <button
//             onClick={() => navigate("/internationalLeaders")}
//             style={{
//               marginTop: 10,
//               padding: "10px 20px",
//               backgroundColor: "#007bff",
//               color: "#fff",
//               border: "none",
//               borderRadius: 5,
//               cursor: "pointer"
//             }}
//           >
//             International Leader
//           </button>
//         </div>

//         {/* Right Image + Button */}
//         <div style={{ margin: 10, textAlign: "center" }}>
//           <img
//             src="/right-image.jpg"
//             alt="Leader from India"
//             style={{ width: "100%", maxWidth: 300, height: "auto" }}
//           />
//           <button
//             onClick={() => navigate("/indiadirectory")}
//             style={{
//               marginTop: 10,
//               padding: "10px 20px",
//               backgroundColor: "#28a745",
//               color: "#fff",
//               border: "none",
//               borderRadius: 5,
//               cursor: "pointer"
//             }}
//           >
//             Leader from India
//           </button>
//         </div>
//       </div>

//       {/* Country List */}
//       <div style={{ textAlign: "center" }}>
//         <h2>Country List</h2>
//         <div
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "center",
//             gap: 20
//           }}
//         >
//           {countries.map((country) => (
//             <div
//               key={country.name}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: 10,
//                 borderRadius: 8,
//                 width: 150,
//                 boxShadow: "2px 2px 5px rgba(0,0,0,0.1)"
//               }}
//             >
//               <div style={{ fontSize: 32 }}>{country.flag}</div>
//               <div style={{ fontWeight: "bold" }}>{country.name}</div>
//               <div style={{ color: "#555" }}>{country.year}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LeadersPage;

// src/LeadersPage.js


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import india from '../images/india.png'
// import international from '../images/international.png'
// const LeadersPage = () => {
//   const navigate = useNavigate();

//   const countries = [
//     { name: "India", year: 1956, code: "in" },
//     { name: "Afghanistan", year: 2018, code: "af" },
//     { name: "Bahrain", year: 1978, code: "bh" },
//     { name: "Bangladesh", year: 1958, code: "bd" },
//     { name: "Bhutan", year: 2010, code: "bt" },
//     { name: "Iraq", year: 2006, code: "iq" },
//     { name: "Jordan", year: 1953, code: "jo" },
//     { name: "Lebanon", year: 1952, code: "lb" },
//     { name: "Maldives", year: 2006, code: "mv" },
//     { name: "Nepal", year: 1971, code: "np" },
//     { name: "Pakistan", year: 1956, code: "pk" },
//     { name: "Palestine", year: 2009, code: "ps" },
//     { name: "Srilanka", year: 1958, code: "lk" },
//     { name: "UAE", year: 2015, code: "ae" }
//   ];

//   return (
//     <div style={{ padding: 20, fontFamily: "Arial, sans-serif" }}>
//       {/* Image Section */}
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           justifyContent: "center",
//           marginBottom: 30
//         }}
//       >
//         {/* Left Image + Button */}
//         <div style={{ margin: 10, textAlign: "center" }}>
//           <img
//             src={international}
//             alt="International Leader"
//             style={{ width: "100%", maxWidth: 300, height: "auto" }}
//           />
//           <button
//             onClick={() => navigate("/internationalLeaders")}
//             style={{
//               marginTop: 10,
//               padding: "10px 20px",
//               backgroundColor: "#007bff",
//               color: "#fff",
//               border: "none",
//               borderRadius: 5,
//               cursor: "pointer"
//             }}
//           >
//             International Leader
//           </button>
//         </div>

//         {/* Right Image + Button */}
//         <div style={{ margin: 10, textAlign: "center" }}>
//           <img
//             src={india}
//             alt="Leader from India"
//             style={{ width: "100%", maxWidth: 300, height: "auto" }}
//           />
//           <button
//             onClick={() => navigate("/indiadirectory")}
//             style={{
//               marginTop: 10,
//               padding: "10px 20px",
//               backgroundColor: "#28a745",
//               color: "#fff",
//               border: "none",
//               borderRadius: 5,
//               cursor: "pointer"
//             }}
//           >
//             Leader from India
//           </button>
//         </div>
//       </div>

//       {/* Country List */}
//       <div style={{ textAlign: "center" }}>
//         <h2>Country List</h2>
//         <div
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "center",
//             gap: 20
//           }}
//         >
//           {countries.map((country) => (
//             <div
//               key={country.name}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: 10,
//                 borderRadius: 8,
//                 width: 150,
//                 boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
//                 textAlign: "center"
//               }}
//             >
//               <img
//                 src={`https://flagcdn.com/w80/${country.code}.png`}
//                 alt={`${country.name} flag`}
//                 style={{ width: 60, height: "auto", marginBottom: 10 }}
//               />
//               <div style={{ fontWeight: "bold" }}>{country.name}</div>
//               <div style={{ color: "#555" }}>{country.year}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LeadersPage;


// import React from "react";
// import { useNavigate } from "react-router-dom";
// import india from '../images/india.png';
// import international from '../images/international.png';

// const LeadersPage = () => {
//   const navigate = useNavigate();

//   const countries = [
//     { name: "India", year: 1956, code: "in" },
//     { name: "Afghanistan", year: 2018, code: "af" },
//     { name: "Bahrain", year: 1978, code: "bh" },
//     { name: "Bangladesh", year: 1958, code: "bd" },
//     { name: "Bhutan", year: 2010, code: "bt" },
//     { name: "Iraq", year: 2006, code: "iq" },
//     { name: "Jordan", year: 1953, code: "jo" },
//     { name: "Lebanon", year: 1952, code: "lb" },
//     { name: "Maldives", year: 2006, code: "mv" },
//     { name: "Nepal", year: 1971, code: "np" },
//     { name: "Pakistan", year: 1956, code: "pk" },
//     { name: "Palestine", year: 2009, code: "ps" },
//     { name: "Srilanka", year: 1958, code: "lk" },
//     { name: "UAE", year: 2015, code: "ae" }
//   ];

//   return (
//     <div style={{ padding: 20, fontFamily: "Arial, sans-serif" }}>
//       {/* Image Section */}
//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           justifyContent: "center",
//           marginBottom: 30
//         }}
//       >
//         {/* International Leader */}
//         <div
//           onClick={() => navigate("/internationalLeaders")}
//           style={{
//             position: "relative",
//             margin: 10,
//             width: 300,
//             cursor: "pointer"
//           }}
//         >
//           <img
//             src={international}
//             alt="International Leader"
//             style={{ width: "100%", height: "auto", display: "block", borderRadius: 5 }}
//           />
//           <button
//             style={{
//               position: "absolute",
//               bottom: 10,
//               left: "50%",
//               transform: "translateX(-50%)",
//               padding: "10px 20px",
//               backgroundColor: "#007bff",
//               color: "#fff",
//               border: "none",
//               borderRadius: 5,
//               cursor: "pointer"
//             }}
//           >
//             International Leader
//           </button>
//         </div>

//         {/* Leader from India */}
//         <div
//           onClick={() => navigate("/indiadirectory")}
//           style={{
//             position: "relative",
//             margin: 10,
//             width: 300,
//             cursor: "pointer"
//           }}
//         >
//           <img
//             src={india}
//             alt="Leader from India"
//             style={{ width: "100%", height: "auto", display: "block", borderRadius: 5 }}
//           />
//           <button
//             style={{
//               position: "absolute",
//               bottom: 10,
//               left: "50%",
//               transform: "translateX(-50%)",
//               padding: "10px 20px",
//               backgroundColor: "#28a745",
//               color: "#fff",
//               border: "none",
//               borderRadius: 5,
//               cursor: "pointer"
//             }}
//           >
//             Leader from India
//           </button>
//         </div>
//       </div>

//       {/* Country List */}
//       <div style={{ textAlign: "center" }}>
//         <h2>Country List</h2>
//         <div
//           style={{
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "center",
//             gap: 20
//           }}
//         >
//           {countries.map((country) => (
//             <div
//               key={country.name}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: 10,
//                 borderRadius: 8,
//                 width: 150,
//                 boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
//                 textAlign: "center"
//               }}
//             >
//               <img
//                 src={`https://flagcdn.com/w80/${country.code}.png`}
//                 alt={`${country.name} flag`}
//                 style={{ width: 60, height: "auto", marginBottom: 10 }}
//               />
//               <div style={{ fontWeight: "bold" }}>{country.name}</div>
//               <div style={{ color: "#555" }}>{country.year}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LeadersPage;


import React from "react";
import { useNavigate } from "react-router-dom";
import india from '../images/india.png';
import international from '../images/international.png';

const LeadersPage = () => {
  const navigate = useNavigate();

  const countries = [
    { name: "India", year: 1956, code: "in" },
    { name: "Afghanistan", year: 2018, code: "af" },
    { name: "Bahrain", year: 1978, code: "bh" },
    { name: "Bangladesh", year: 1958, code: "bd" },
    { name: "Bhutan", year: 2010, code: "bt" },
    { name: "Iraq", year: 2006, code: "iq" },
    { name: "Jordan", year: 1953, code: "jo" },
    { name: "Lebanon", year: 1952, code: "lb" },
    { name: "Maldives", year: 2006, code: "mv" },
    { name: "Nepal", year: 1971, code: "np" },
    { name: "Pakistan", year: 1956, code: "pk" },
    { name: "Palestine", year: 2009, code: "ps" },
    { name: "Srilanka", year: 1958, code: "lk" },
    { name: "UAE", year: 2015, code: "ae" }
  ];

  return (
    <div style={{ padding: 20, fontFamily: "Arial, sans-serif" }}>
      {/* Image Section */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: 30
        }}
      >
        {/* International Leader */}
        <div
          onClick={() => navigate("/internationalLeaders")}
          style={{
            position: "relative",
            margin: 10,
            width: 500,
            cursor: "pointer"
          }}
        >
          <img
            src={international}
            alt="International Leader"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
              borderRadius: 5
            }}
          />
          {/* <button
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              padding: "12px 20px",
              backgroundColor: "rgba(0, 123, 255, 0.9)",
              color: "#fff",
              border: "none",
              borderRadius: 5,
              cursor: "pointer"
            }}
          >
            International Leader
          </button> */}
        </div>

        {/* Leader from India */}
        <div
          onClick={() => navigate("/indiadirectory")}
          style={{
            position: "relative",
            margin: 10,
            width: 500,
            cursor: "pointer"
          }}
        >
          <img
            src={india}
            alt="Leader from India"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
              borderRadius: 5
            }}
          />
          {/* <button
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              padding: "12px 20px",
              backgroundColor: "rgba(40, 167, 69, 0.9)",
              color: "#fff",
              border: "none",
              borderRadius: 5,
              cursor: "pointer"
            }}
          >
            Leader from India
          </button> */}
        </div>
      </div>

      {/* Country List */}
      <div style={{ textAlign: "center" }}>
        <h2>Country List</h2>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 20
          }}
        >
          {countries.map((country) => (
            <div
              key={country.name}
              style={{
                border: "1px solid #ccc",
                padding: 10,
                borderRadius: 8,
                width: 150,
                boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
                textAlign: "center"
              }}
            >
              <img
                src={`https://flagcdn.com/w80/${country.code}.png`}
                alt={`${country.name} flag`}
                style={{ width: 60, height: "auto", marginBottom: 10 }}
              />
              <div style={{ fontWeight: "bold" }}>{country.name}</div>
              <div style={{ color: "#555" }}>{country.year}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadersPage;
